// ConsensoVolto.tsx — prima della prima partita (v021, scelte legali 5 e 6): cosa fa il telefono con il volto, in
// quattro righe, e la spunta «Ho capito, va bene». Senza spunta non si gioca. Vale per la sfida 1v1, «Prova da solo»,
// le partite del torneo e la partita a 4 (la chiamano Gioco e Gruppo prima della fotocamera).
// v045: solo questo. «Le tue scelte» (foto, video, video per noi, Wall of Fame) si chiedono DOPO la prima partita
// (componenti/DomandaScelte.tsx): prima di giocare una cosa sola da leggere.
import { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "../componenti/Avatar.tsx";
import { accettaVolto, useAvatar, voltoAccettato, voltoAggiornato } from "../servizi/account.ts";
import { BASE_API, PERCORSO_PRIVACY } from "../costanti.ts";

export function ConsensoVolto({ onAccettato, onEsci, annulla }: { onAccettato: () => void; onEsci: () => void; annulla?: string }) {
  const { t, i18n } = useTranslation();
  const avatar = useAvatar();
  const [serveVolto] = useState(() => !voltoAccettato());
  const [spunta, setSpunta] = useState(false);
  const [invio, setInvio] = useState(false);
  // v040: il pulsante non è mai spento (chi lo tocca senza la spunta vede cosa manca)
  const [richiamo, setRichiamo] = useState(0);
  const id = useId();
  const aggiornato = voltoAggiornato();
  const pronto = !serveVolto || spunta;

  const continua = () => {
    if (!pronto) {
      setRichiamo((n) => n + 1);
      document.getElementById(`${id}-spunta`)?.focus();
      return;
    }
    setInvio(true);
    const lavori: Promise<unknown>[] = [];
    if (serveVolto) lavori.push(accettaVolto());
    // la partita non aspetta il server
    void Promise.race([Promise.all(lavori), new Promise((ok) => setTimeout(ok, 1500))]).finally(onAccettato);
  };

  return (
    <div className="pagina ld-pagina ld-volto">
      <div className="ld-alone" aria-hidden="true" />
      <main className="ld-volto-centro">
        <Avatar quale={avatar} dimensione={96} anello classe="ld-volto-avatar" />
        <h1 className="ld-titolo ld-centrato" id={`${id}-titolo`}>
          {t("volto.titolo")}
        </h1>
        {serveVolto && (
          <>
            {aggiornato && (
              <p className="ld-volto-aggiornato" role="status">
                {t("volto.aggiornato")}
              </p>
            )}
            <ul className="ld-volto-righe">
              {(["riga1", "riga2", "riga3", "riga4"] as const).map((k, i) => (
                <li key={k} data-riga={i + 1}>
                  <span className="ld-volto-icona" aria-hidden="true">
                    {["👀", "🤖", "📱", "🙈"][i]}
                  </span>
                  <span>{t(`volto.${k}`)}</span>
                </li>
              ))}
            </ul>
            <a className="ld-volto-link" href={`${BASE_API}${PERCORSO_PRIVACY}?lingua=${encodeURIComponent(i18n.language)}`} target="_blank" rel="noopener">
              {t("volto.link")}
            </a>
            <label className="ld-volto-spunta ld-volto-obbligatoria" data-richiamo={richiamo > 0 && !spunta ? richiamo % 2 : undefined}>
              <input id={`${id}-spunta`} type="checkbox" checked={spunta} onChange={(e) => setSpunta(e.target.checked)} aria-describedby={spunta ? undefined : `${id}-serve`} />
              <span>{t("volto.spunta")}</span>
            </label>
          </>
        )}
        {!pronto && (
          <p className="ld-volto-serve" id={`${id}-serve`} role={richiamo > 0 ? "alert" : undefined} data-forte={richiamo > 0 || undefined}>
            {t("volto.serve_spunta")}
          </p>
        )}
        <button type="button" className="ld-cta ld-cta-centrata" disabled={invio} onClick={continua}>
          {t("volto.pulsante")}
        </button>
        <button type="button" className="pulsante" onClick={onEsci}>
          {annulla ?? t("generale.annulla")}
        </button>
      </main>
    </div>
  );
}

/** Serve la schermata (spiegazione del volto non ancora accettata, o aggiornata)? */
export function serveConsenso(): boolean {
  return !voltoAccettato();
}
